import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
  Signal,
  afterNextRender,
  viewChild,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { ReactiveMap } from '@core/shared/util';
import {
  PlattformPackungseinheit,
  PlattformPackungseinheitMapping,
  UpdateUnit,
} from '@mp/content-manager/industriekataloge/data-access';

import { PackungseinheitenSelectorComponent } from '../../../packungseinheiten-selector/packungseinheiten-selector.component';

@Component({
  selector: 'mp-packaging-unit-col',
  templateUrl: './packaging-unit-col.component.html',
  styleUrl: './packaging-unit-col.component.scss',
  imports: [MatIconButton, MatIcon, PackungseinheitenSelectorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackagingUnitColComponent {
  readonly packagingUnitSelector: Signal<PackungseinheitenSelectorComponent | undefined> = viewChild(
    PackungseinheitenSelectorComponent,
  );

  assignedUnit: ReactiveMap<string, string | undefined> = new ReactiveMap<string, string | undefined>({});

  @Input() canWritePackagingUnits = false;
  @Input() unit!: PlattformPackungseinheitMapping;
  @Input() platformPackagungUnits: PlattformPackungseinheit[] = [];

  @Output() readonly saveUnitMapping: EventEmitter<UpdateUnit> = new EventEmitter<UpdateUnit>();

  constructor(private readonly injector: Injector) {}

  onUnitChange(unit: PlattformPackungseinheitMapping, value: PlattformPackungseinheit | null): void {
    this.assignedUnit.set(unit.shortName, value?.shortName);
  }

  deleteUnitMapping(unit: PlattformPackungseinheitMapping): void {
    if (unit.viaDataSource) {
      unit.mappedShortName = undefined;

      afterNextRender({ read: () => this.packagingUnitSelector()?.focus() }, { injector: this.injector });
      return;
    }
    this.saveUnitMapping.emit({ unit });
  }

  saveUnit(unit: PlattformPackungseinheitMapping): void {
    const mappedShortName = this.assignedUnit.get(unit.shortName);
    this.saveUnitMapping.emit({ unit, mappedShortName });
  }
}
